<zef-dialog
  [paneClass]="'c-dialog-no-padding'"
  [open]="isOpen$ | async"
  (closeTrigger)="onCloseTrigger()">
  <ng-template
    [ngTemplateOutlet]="tpl"
    [ngTemplateOutletContext]="{ data: (dialogErrorsDelayed$ | async) }">
  </ng-template>
</zef-dialog>
